/* eslint-disable */
import { useEffect, useState, useContext} from 'react';

import SearchBar from '../UserManagement/searchBar';
import DataGridComponent from '../../Components/DataGrid/dataGrid';
import ControlledSwitches from '../../Components/Switch/switch';
import UseAxios from '../../Api/http/http';


import {
  DEAL_PARAMTER_FIELD,
  DEAL_PARAMTER_HEADER,
  DEAL_PARAMTER_MASTER,
  ENABLE_DISABLE_DEALSTATUS_DLG,
} from '../../Constants/strings';

import styles from './dealParameterMaster.module.scss';
import { enableOrDisabledealSla, enableOrDisabledealWorkflow, parametersList } from '../../Api/request/parameters';
import { useSnackbar } from '../../Components/Snackbar/snackBarProvider';
import { AuthContext } from '../../Contexts/AuthContext';
import { STATUS_CODES } from '../../Api/resources/statusCodes';
import { MODULE_NAMES } from '../../Constants/modules';
import PuzzleLoader from '../../Assets/images/svg/loading puzzle.gif';


const DealParameter = () => {
  const [searchText, setSearchText] = useState('');
  const [parameters, setParameters] = useState([]);
  const [isMobileView, setIsMobileView] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { snackbarOpen } = useSnackbar();
  const { userProfile } = useContext(AuthContext);

  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.MASTER_DEAL_PARAMETERS] || []
    : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };



  useEffect(() => {    
    const fetchData = async () => {
      setIsLoading(true);      
      try {
        const value = await UseAxios(parametersList());
        const rows = value.data.response.map((parameter) => ({
          ...parameter,
          id: parameter.parameter_id,
          sla: !!parameter.sla,
          workflow: !!parameter.workflow,
        }));
       setParameters(rows);
       setIsLoading(false);
      } catch (err) {
        console.error('Error fetching data:', err);
        setIsLoading(false);
      }
    };

    fetchData();

  }, []);

  useEffect(() => {
    if (isEdit) {
      setIsEdit(false);
    }
  }, [parameters]);

  useEffect(() => {
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 768);
  };


  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const onToggle = async (params, column) => {
    const updatedValue = !params.row[column];  
    const data = { [column]: updatedValue };
    try {
      let response =null;
      if (column === 'sla') {
         response = await UseAxios(enableOrDisabledealSla(data,params.row.id));       
      } else if (column === 'workflow') {
         response = await UseAxios(enableOrDisabledealWorkflow(data,params.row.id));
      }
      if (response.data.status === STATUS_CODES.SUCCESS) {
      setParameters((parameters) => {
        return parameters.map((parameter) => {
          if (params.row.id === parameter.id) {
            return {
              ...parameter,
              [column]: updatedValue,
            };
          } else {
            return parameter;
          }
        });
      });
      setIsEdit(true);
    } else {
        snackbarOpen(ENABLE_DISABLE_DEALSTATUS_DLG.CANNOT_DISABLE, 'warning');
      }
    }
    catch (error) {
      snackbarOpen(ENABLE_DISABLE_DEALSTATUS_DLG.OOPS_TRY_AGAIN, 'warning');
      console.error(`Error toggling ${column}:`, error);
    }
  };



  // eslint-disable-next-line operator-linebreak
  const filteredRows =
    searchText.length >= 1
      ? parameters.filter((parameter) => {
        return (
          parameter?.parameter_name?.toLowerCase().includes(searchText)
            || parameter?.data_type?.toLowerCase().includes(searchText)
            || parameter?.remarks?.toLowerCase().includes(searchText)
        );
      })
      : parameters;

  const columns = [
    {
      field: DEAL_PARAMTER_FIELD.NAME,
      headerName: DEAL_PARAMTER_HEADER.PARAMETER,
      headerClassName: '',
      cellClassName: '',
      width: isMobileView ? 200 : undefined,
      flex: !isMobileView ? 0.75 : undefined,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: DEAL_PARAMTER_FIELD.DATA_TYPE,
      headerName: DEAL_PARAMTER_HEADER.DATA_TYPE,
      headerClassName: '',
      cellClassName: '',
      width: isMobileView ? 125 : undefined,
      flex: !isMobileView ? 0.5 : undefined,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: DEAL_PARAMTER_FIELD.REMARKS,
      headerName: DEAL_PARAMTER_HEADER.REMARKS,
      headerClassName: '',
      cellClassName: '',
      width: isMobileView ? 250 : undefined,
      flex: !isMobileView ? 1.2 : undefined,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: DEAL_PARAMTER_FIELD.IS_SLA_ENABLED,
      headerName: DEAL_PARAMTER_HEADER.USE_FOR_SLA,
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      width: isMobileView ? 140 : undefined,
      flex: !isMobileView ? 0.6 : undefined,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div className={styles['sla-container']}>
            <ControlledSwitches
               disabled={!hasAccess('update')} // Disable switch based on permission
              checked={params.row.sla}
              handleChange={() => {
                onToggle(params, 'sla');
              }}
            />
            <span>SLA</span>
          </div>
        );
      },
    },
    {
      field: DEAL_PARAMTER_FIELD.IS_WORKFLOW_ENABLED,
      headerName: DEAL_PARAMTER_HEADER.USE_FOR_WORKFLOW,
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      width: isMobileView ? 180 : undefined,
      flex: !isMobileView ? 0.7 : undefined,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div className={styles['workflow-container']}>
            <ControlledSwitches
               disabled={!hasAccess('update')} // Disable switch based on permission
              checked={params.row.workflow}
              handleChange={() => {
                onToggle(params, 'workflow');
              }}
            />
            <span>Workflow</span>
          </div>
        );
      },
    },
  ];

  const sortFilterColumns = [
    columns[0].field,
    columns[1].field,
    columns[2].field,
    columns[3].field,
    columns[4].field,
  ];

  return (
    <div className={styles['outer-layer']}>
      <div className={styles.container}>
        <header>
          <h2>{DEAL_PARAMTER_MASTER}</h2>
        </header>
        <div className={styles['search-container']}>
          <SearchBar searchText={searchText} handleSearch={handleSearch} />
        </div>
        <div className={styles['grid-container']}>
          {isLoading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '20px',
              }}
            >
              <img
                src={PuzzleLoader}
                alt="Loading..."
                className="loader-gif"
                style={{ width: '100px', height: 'auto' }}
              />
            </div>
          ) : filteredRows ? (
            <DataGridComponent
              dataRows={filteredRows}
              dataColumns={columns}
              sortFilterColumns={sortFilterColumns}
              pageSize={10}
              isFilteredRows={filteredRows}
              isEdit={isEdit}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default DealParameter;
